//TODO: Cleanup the below code, standardize variable and function naming. Merge 'profile' and 'orchestra' variables
import "../vendor/bootstrap_combined"
;(function ($$, $) {
  let unfollow_confirmed = function (e) {
    slideshare_object.ga("Profiles", "slidespace_orchestra_unfollow")

    $(e.target).parent().next().next().show()
    $(e.target).parent().hide()
    let successCB = function () {
      $(e.target).parent().next().next().hide()
      $(e.target).parent().next().show()
    }
    let failCB = function () {
      $(e.target).parent().next().next().hide()
      $(e.target).parent().show()
    }
    slideshare_object.delete_contact(slideshare_object.owner.id, successCB, failCB)
  }

  let confirm_box = function (title, message, callback) {
    title = title || "Confirm"
    message = message || "Are you sure you want to proceed?"
    //escaping html from message
    message = $("<div>").text(message).html()
    const dialog =
      '<div id="dialog" style="display:none;" title="' +
      title +
      '"><p><span class="ui-icon ui-icon-info" style="float:left; margin:0 7px 20px 0;"></span>' +
      message +
      "</p></div>"
    $("body").append(dialog)

    $("#dialog").dialog({
      bgiframe: true,
      resizable: false,
      height: 140,
      modal: false,
      overlay: {
        backgroundColor: "#000",
        opacity: 0.5,
      },
      closeOnEscape: true,
      dialogClass: "confirm",
      close: function () {
        $(this).dialog("destroy")
      },
      buttons: {
        Unfollow: function () {
          $(this).dialog("close")
          callback()
        },
        Close: function () {
          $(this).dialog("close")
        },
      },
    })
  }

  let orchestra = {
    register_listeners: function () {
      //Follow link
      $("a.j-follow").on("click", function (e) {
        let contactee = $(this).attr("data-contactee")
        if (slideshare_object.user.loggedin) {
          $(e.target).parent().next().show()
          $(e.target).parent().hide()
          slideshare_object.ga("Profiles", "slidespace_orchestra_follow", $(this).attr("data-ga"))
          slideshare_object.add_contact(contactee, function (response) {
            $(e.target).parent().next().hide()
            if (response.success) {
              slideshare_object.ga("Profiles", "slidespace_orchestra_follow_successful", $(this).attr("data-ga"))
              $(e.target).parent().prev().show()
            } else {
              $(e.target).parent().show()
              slideshare_object.ga("Profiles", "slidespace_orchestra_follow_failure", $(this).attr("data-ga"))
            }
          })
          return false
        } else {
          let eventConfig = {
            event: "follow",
            data: { contactee: contactee },
          }
          slideshare_object.addAfterLoginEvent(eventConfig)
        }
      })

      //Unfollow link
      $("a.j-unfollow").on("click", function (e) {
        let message = "You are following " + slideshare_object.owner.return_name
        confirm_box("Following", message, function () {
          unfollow_confirmed(e)
        })
        return false
      })

      //Tipsy tooltips
      $(".j-tooltip").tooltip()
    },

    block_interaction: function () {
      let showModalBox = function (myHeading, myBody) {
        $("#myModal").modal({ backdrop: "static" })
        $("#myModalLabel").html(myHeading)
        $(".modal-body p").html(myBody)
        $("#myModal").modal("show").find(".modal-footer").show()
      }

      $(".j-block-user").on("click", function (e) {
        $(".modal-footer .j-yes").attr("id", "block")
        showModalBox("Block User", "Are you sure you want to block the user?")
      })

      $(".j-unblock-user").on("click", function (e) {
        $(".modal-footer .j-yes").attr("id", "unblock")
        showModalBox("Unblock User", "Are you sure you want to unblock the user?")
      })

      $(".modal-footer .j-yes").on("click", function (e) {
        let modalBody = $(".modal-body p"),
          action = this.id,
          id = $(this).attr("data-id")

        modalBody.html("<img src='//public.slidesharecdn.com/images/indicator.gif' height='5' width='21'/>")
        $(".modal-footer").slideUp("slow")

        $.post("//" + document.location.host + "/block/" + action, { blocked_id: id }, function (data) {
          if (data.success) {
            modalBody.html("The user has been " + action + "ed.")

            if (action == "block") {
              $(".j-block-user").text("Unblock User").removeClass().addClass("j-unblock-user")
            } else {
              $(".j-unblock-user").text("Block User").removeClass().addClass("j-block-user")
            }
            const myModal = $("#myModal")
            setTimeout(function () {
              myModal.modal("hide")
            }, 3000)
          } else {
            modalBody.html("Oops! Something went wrong. Please try again later.")
          }
        }) // post closed
      }) // click closed
    },

    adjust_height: function () {
      $(".sidebar").css("height", "")
      $(".mainContent").css("height", "")
      let sidebar_total_height = $(".sidebar").outerHeight()
      let main_content_total_height = $(".mainContent").outerHeight()
      if (sidebar_total_height > main_content_total_height) {
        let main_padding = main_content_total_height - $(".mainContent").height()
        $(".mainContent").height(sidebar_total_height - main_padding)
      } else {
        let sidebar_padding = sidebar_total_height - $(".sidebar").height()
        $(".sidebar").height(main_content_total_height - sidebar_padding)
      }
    },
  }

  var profile = {
    cache: {},
    tags_interaction: function () {
      $("#showMoreTags,#showLessTags").click(function (e) {
        if (e.target.id == "showMoreTags") {
          $("#tagsLess").hide().siblings("#tagsMore").show()
          $("#search_uploaded_tags").show()
          if (typeof orchestra !== "undefined") {
            orchestra.adjust_height()
          }
        } else {
          $("#tagsMore").hide().siblings("#tagsLess").show()
          $("#search_uploaded_tags").hide()
          if (typeof orchestra !== "undefined") {
            orchestra.adjust_height()
          }
        }
        return false
      })
    },
    removeFavorites: function () {
      let e = profile.cache.removeFavoriteElement,
        element = $(e.target),
        parent = element.parents("li"),
        slideshow_id = element.attr("href").split("#")[1],
        user_id = slideshare_object.owner.id
      delete profile.cache.removeFavoriteElement
      $(".j-fav_count").html(parseInt($(".j-fav_count").html(), 10) - 1)
      element.next().show()
      $.post(
        "/favorite/delete",
        {
          slideshow_id: slideshow_id,
          user_id: user_id,
        },
        function () {
          let siblings = parent.siblings()
          parent.hide(1000, function () {
            parent.remove()
            $.each(siblings, function (i, j) {
              let element = $(j)
              element.removeClass("last")
              if ((i + 1) % 4 === 0) {
                element.addClass("last")
              }
            })
          })
        }
      )
      return false
    },
    confirmRemoveFavorites: function (e) {
      profile.cache.removeFavoriteElement = e
      if ($$.confirm("Confirm", "Are you sure want to remove this from favorites ?", profile.removeFavorites)) {
        delete profile.cache.removeFavoriteElement
      }
    },
    updateFavoriteTags: function (value) {
      let element = profile.cache.editTag
      let data = {
        user_id: slideshare_object.owner.id,
        slideshow_id: element.attr("href").split("#")[1],
        "favorite[tag_text]": value,
      }
      $.post("/favorite/update", data, function () {
        window.location.reload()
      })
    },
    editFavoriteTags: function (e) {
      let element = $(e.target),
        tags_array = element.parent().parent().children(".tags"),
        tags_text = ""
      profile.cache.editTag = element
      $.each(tags_array, function (i, j) {
        tags_text += $(j).html() + ","
      })
      tags_text = tags_text.slice(0, -1)
      $$.prompt("Please update the tags", "Tags :", tags_text, profile.updateFavoriteTags)
      let elem = $("#prompt_value")
      $$.tagTextBoxInteraction(elem)
      return false
    },
    searchUploadedTags: function (e) {
      let element = $(e.target),
        value = element.val()
      if (value !== "") {
        $("#tagsMore span")
          .hide()
          .filter("[id*=" + value + "]")
          .show()
      } else {
        $("#tagsMore span").show()
      }
    },
    pixel_tracker: function () {
      try {
        if ($$.pixel_tracker) {
          $("body").append($$.pixel_tracker)
        }
      } catch (e) {
        window._gaq = _gaq || []
        _gaq.push(["_trackEvent", "Pixel tracker errors", e.toString(), window.location.href])
      }
    },
    fb_app_tracker: function () {
      let fb_source = getUrlVar("fb_source")
      if (getUrlVar("code") || fb_source) {
        if (fb_source) {
          slideshare_object.ga("fb_opengraph", "profile_visit", fb_source)
        } else {
          slideshare_object.ga("fb_opengraph", "profile_visit", "no_fb_source")
        }
      }
    },
    showToolTip: function () {
      jQuery(".getToolTip").hover(
        function () {
          jQuery(this).siblings("span.tooltip").show()
        },
        function () {
          jQuery(this).siblings("span.tooltip").hide()
        }
      )
    },
    subscriptionCta: function () {
      window._gaq = _gaq || []
      _gaq.push(["_trackEvent", "subscription", "subscriptionCtaProfile"])
    },
    proCtaTracker: function () {
      $(".j-ad_remove").click(function () {
        window._gaq = _gaq || []
        _gaq.push(["_trackEvent", "Profiles", "remove_ad_cta_clicked"])
      })
    },
    search_interaction: function () {
      $("#search_uploaded_tags").keyup(profile.searchUploadedTags)
      $("#search_uploaded_tags").focus(function (e) {
        let element = e.target,
          type = "search_favorite_tags"
        if (element.value === "search") {
          element.value = ""
        }
        $$.ga("Profiles", "slidespace_" + type)
      })
      $("#search_uploaded_tags").blur(function (e) {
        let element = e.target
        if (element.value === "") {
          element.value = "search"
        }
      })
      $("#search_content")
        .focus(function () {
          if (
            (!profile.cache.search_content || profile.cache.search_content == this.value) &&
            this.value.match("Search content from ")
          ) {
            profile.cache.search_content = this.value
            this.value = ""
          }
          $$.ga("Profiles", "slidespace_search_content")
        })
        .blur(function () {
          this.value = this.value === "" ? profile.cache.search_content : this.value
        })
    },
    async_thumbnails_load: function () {
      let items = [
        {
          selector: ".thumbnailFollowGrid>li a>span>img.nickname",
          options: { effect: "fadeIn", placeholder: window.slideshowPlaceholder },
        },
      ]
      $(items).each(function (i, item) {
        $(item.selector).lazyload(item.options)
      })
    },
  }

  function sticky() {
    let marginTop = 10
    if ($("body").hasClass("sticky_navbar")) {
      marginTop = $("#main_navbar").height() + 20
    }
    $("#j-sticky-widgets-profile").scrollToFixed({
      marginTop: marginTop,
      limit: function () {
        let limit = $("footer").offset().top - 750
        return limit
      },
    })
  }

  $(document).ready(function () {
    //Removing stickiness temporarily to fix profile pages
    //sticky();
    profile.tags_interaction()
    $(".remove_favorited").click(profile.confirmRemoveFavorites)
    $(".edit_tags").click(profile.editFavoriteTags)
    profile.search_interaction()
    profile.pixel_tracker()
    //Trigger GA when the page is called from fb app
    profile.fb_app_tracker()
    if ($(".upgrade_subscription").length > 0) {
      profile.showToolTip()
      profile.subscriptionCta()
    }
    profile.proCtaTracker()
    if (typeof innerpage === "undefined") {
      profile.async_thumbnails_load()
    }
    orchestra.register_listeners()
    orchestra.block_interaction()

    let delay_in_secs = typeof innerpage === "undefined" ? 5 : 0
    window.setTimeout(orchestra.adjust_height, delay_in_secs * 1000)

    $("form#j-flag-user").on("ajax:beforeSend", function (event, data) {
      let id = slideshare_object.owner.id + ""
      $("#ban_user_email_progress_" + id).show()
    })

    $("form#j-flag-user").on("ajax:complete", function (event, data) {
      let id = slideshare_object.owner.id + ""
      if (data.status === 200) {
        $("#ban_user_email_" + id).html(data.responseText)
      } else {
        $("#ban_user_email_progress_" + id).hide()
      }
    })

    $("a#j-warning-email").on("ajax:beforeSend", function (event, data) {
      let id = slideshare_object.owner.id + ""
      $("#ban_user_email_progress_" + id).show()
    })

    $("a#j-warning-email").on("ajax:complete", function (event, data) {
      let id = slideshare_object.owner.id + ""
      $("#ban_user_email_progress_" + id).hide()
    })

    slideshare_object.action_from_email_check()
  })
})(slideshare_object, jQuery)
